import React from 'react';
import styles from './headerpanel.module.scss';
import { isEmptyString } from '../common/utility';

const HeaderBar = ({ headerTitle, subTitle }) => {
  return (
    <header className={styles.headerBarWrapper}>
      <nav
        className="navbar"
        role="navigation"
        aria-label="main navigation"
      >
        <span className={styles.title}>{headerTitle || "GSMA EAR"}</span>

        {!isEmptyString(subTitle) && (
          <span className={styles.subTitle}>
            {subTitle}
          </span>
        )}
      </nav>
    </header>
  );
};

export default HeaderBar;
